import { dataConstants } from "_constants";

const initialState = {
  mifiTable: {
    mifiDeviceCost: {
      val: "150",
      error: {
        status: false,
        msg: null
      }
    },
    mifiMonthlyCharge: {
      val: "50",
      error: {
        status: false,
        msg: null
      }
    },
    statisticNumberConnections: {
      val: "100",
      error: {
        status: false,
        msg: null
      }
    },
  },
  btsEndTable: {
    btsEndInfrastructureCost: {
      val: "6000",
      error: {
        status: false,
        msg: null
      }
    },
    btsEndApAntennaCost: {
      val: "4792",
      error: {
        status: false,
        msg: null
      }
    }
  },
  cpeEndTable: {
    cpeEndInstallationTimeCost: {
      val: "150",
      error: {
        status: false,
        msg: null
      }
    },
    cpeEndOneTimeCost: {
      val: "70",
      error: {
        status: false,
        msg: null
      }
    },
    cpeEndMonthlyCharge: {
      val: "40",
      error: {
        status: false,
        msg: null
      }
    },
  },
  statisticTable: {
    statisticNumberFaBts: {
      val: "1",
      error: {
        status: false,
        msg: null
      }
    },
    statisticOneTimeCostMiFiAccess: {
      val: "15000",
      error: {
        status: false,
        msg: null
      }
    },
    statisticOneTimeCostFWAccess: {
      val: "33630",
      error: {
        status: false,
        msg: null
      }
    },
    statisticMounthlyRecChargeMifiAccess: {
      val: "50",
      error: {
        status: false,
        msg: null
      }
    },
    statisticMounthlyRecChargeFWAccess: {
      val: "40",
      error: {
        status: false,
        msg: null
      }
    }
  },
  savingCalcTable: {
    savingCalcNumberYears: {
      val: "1",
      error: {
        status: false,
        msg: null
      }
    },
    savingCalcMiFiCost: {
      val: "75000",
      error: {
        status: false,
        msg: null
      }
    },
    savingCalcFWACost: {
      val: "81630",
      error: {
        status: false,
        msg: null
      }
    },
    savingCalcFWASaving: {
      val: "-9",
      error: {
        status: false,
        msg: null
      }
    }
  },
  graphData: []
};

export function dataStore(state = initialState, {type, name, val}) {
  let dataStoreState;
  switch (type) {
    case dataConstants.SET_VAL:
      dataStoreState = {
        ...state,
        [name]: val
      };
      break;
    default:
      dataStoreState = state;
      break;
  }
  return dataStoreState;
}

export default dataStore;
